<template>
  <div class="page">
    <navbar></navbar>
    <div class="content-container">
      <div class="content">
        <div class="examples">
          <img src="../assets/about_1.jpg">
          <img src="../assets/about_2.jpg">
          <img src="../assets/about_3.jpg">
          <img src="../assets/about_4.jpg">
          <img src="../assets/about_5.jpg">
        </div>
        <div class="about-text">
          <div>
            I create both functional and one of a kind sculptural ceramic work.
          </div>
          <div>
            In my functional work my intent is to create pots that are not only functional
            but also invite the user to touch and use these pieces.
          </div>
          <div>
            I frequently manipulate the surface of a piece when it is still wet to capture
            a moment in the life of the clay and to alter and enhance the form both visually and
            functionally.
          </div>
          <div>
            My work is inspired by nature, primarily the colors of the sea, sky, sand and
            soft light that is frequent on the island of Martha’s Vineyard,  and influences by Cynthia
            Bringle and Warren Mckenzie with whom I have studied.
          </div>
        </div>
      </div>
    <div class="footer">
      <!-- <router-link to="/login">Manage</router-link> -->
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'landing',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.footer {
  float: right;
  padding: 0.5em;
  a {
    color: #888;
  }
}
.content-container {
  flex: 1;
  overflow: auto;
}
.content {
  max-width: 40em;
  margin: auto;
  padding: 1em 3em 1em 3em;
  overflow: auto;
  background: #eee;
}
.examples img {
  margin: 1em;
  padding: 10px;
  background: $card-border;
  box-shadow: 3px 3px 4px;
}
.about-text {
  text-align: left;
  font-weight: 500;

  div {
    margin-bottom: 1em;
  }
}
</style>

<!-- global css -->
<style lang="scss">
.page {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue?9c4eacfc